import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object()
    .shape({
      drivingLicenseURL: Yup.string().nullable().url(),
      passportURL: Yup.string().nullable().url(),
      euIDCardURL: Yup.string().nullable().url(),
    })
    .test(
      'at-least-one-document',
      'you must provide at least one document',
      (value) =>
        !!(value.drivingLicenseURL || value.passportURL || value.euIDCardURL)
    ),
});
